export default __webpack_public_path__ + "images/137e2d52f65383b3870d8c89160e24f5.png";